"use client";

import { usePathname } from "next/navigation";

export default function BodyWrapper({
  children,
  className,
}: {
  children: React.ReactNode;
  className: string;
}) {
  const pathname = usePathname();
  const isResumePage = pathname === "/resume";

  // Remove top padding on resume page since there's no header
  const bodyClass = isResumePage
    ? className.replace("pt-28 sm:pt-36", "")
    : className;

  return <div className={bodyClass}>{children}</div>;
}

